import * as React from "react";
import { UitkSecondaryButton } from "uitk-react-button";
import { AnalyticsConfig } from "uitk-react-utils";
import { useLocalization } from "@shared-ui/localization-context";
import { DestinationAttractionsProps } from "./typings";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import { AttractionSection } from "./AttractionSection";
import { inject } from "mobx-react";

export const DestinationAttractions = inject("analytics")((props: DestinationAttractionsProps) => {
  const { flexComponent, context, analytics } = props;
  const attractionsKeyHelper = new ItemKeyHelper("top-attractions");
  const isCountry = context.searchContext?.location?.type === "country";
  const locationName = context.searchContext?.location?.localizedName || context.searchContext?.location?.name;
  let buttonLocationName = locationName;
  const locationType = context.searchContext.location.type;
  if (locationType === "neighborhood" || locationType === "point_of_interest") {
    buttonLocationName = context.searchContext.location.parent.localizedName;
  }
  const { formatText } = useLocalization();

  const pois = flexComponent.model?.content?.pois.filter((attraction) => {
    return attraction.name && attraction.media?.mediaUrl?.length && attraction.description;
  });

  const activities = flexComponent.model?.content?.activities.filter((attraction) => {
    return attraction.name && attraction.media?.mediaUrl?.length && attraction.description;
  });

  const activitiesTravelGuideUrl = flexComponent.model?.content?.activitiesTravelGuideUrl;
  const carouselAnalytics: AnalyticsConfig = {
    id: "TG.LP.Dest.Attractions",
    callback: (id, description) => {
      const flexTrackingInfo: FlexTrackingInfo = {
        moduleName: id,
        action: Action.SCROLL,
        linkName: description,
      };
      sendDelayedTrackEvent(flexTrackingInfo, analytics);
    },
  };

  /* istanbul ignore next */
  const buttonAnalytics: AnalyticsConfig = {
    id: "TG.LP.Dest.Attractions.Activities.Button",
    callback: (id, description) => {
      const flexTrackingInfo: FlexTrackingInfo = {
        moduleName: id,
        action: Action.CLICK,
        linkName: description,
      };
      sendDelayedTrackEvent(flexTrackingInfo, analytics);
    },
  };

  return (
    <div
      className="DestinationAttractions uitk-cell all-cell-1-1"
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
    >
      {Boolean(pois && pois.length) && (
        <AttractionSection
          attractions={pois}
          attractionsKeyHelper={attractionsKeyHelper}
          headingKey={
            isCountry ? "destinationAttractions.country.pois.title" : "destinationAttractions.city.pois.title"
          }
          carouselAnalytics={carouselAnalytics}
          isActivity={false}
          isCountry={isCountry}
          locationName={locationName}
          context={context}
        />
      )}
      {Boolean(activities?.length) && ( // There are never activities for countries.
        <>
          <AttractionSection
            attractions={activities}
            attractionsKeyHelper={attractionsKeyHelper}
            headingKey="destinationAttractions.city.activities.title"
            carouselAnalytics={carouselAnalytics}
            isCountry={isCountry}
            isActivity={true}
            locationName={locationName}
            context={context}
          />
          {Boolean(activitiesTravelGuideUrl) && (
            <div className="uitk-type-center">
              <UitkSecondaryButton
                text={`${
                  Boolean(buttonLocationName) &&
                  formatText("destinationAttractions.city.activities.button.label", buttonLocationName)
                }`}
                href={activitiesTravelGuideUrl}
                analytics={buttonAnalytics}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
});

export default DestinationAttractions;
